var React = require('react');

function Linkedinwhite (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Icon","d":"M24.742,26.72H1.97A1.952,1.952,0,0,1,0,24.792V1.927A1.951,1.951,0,0,1,1.97,0H24.742A1.955,1.955,0,0,1,26.72,1.927V24.792A1.956,1.956,0,0,1,24.742,26.72Zm-14.33-16.7V22.769l3.957,0,0-6.31c0-1.619.282-3.275,2.375-3.275,2.061,0,2.061,1.954,2.061,3.38v6.2l3.962,0V15.775c0-3.155-.576-6.075-4.754-6.075a4.192,4.192,0,0,0-3.75,2.059h-.056V10.017Zm-6.455,0V22.769H7.924l0-12.751Zm1.987-6.34a2.3,2.3,0,1,0,2.3,2.3A2.3,2.3,0,0,0,5.944,3.678Z","fill":"currentColor"}));
}

Linkedinwhite.defaultProps = {"width":"26.721","height":"26.721","viewBox":"0 0 26.721 26.721"};

module.exports = Linkedinwhite;

Linkedinwhite.default = Linkedinwhite;
